'use es6';

import PropTypes from 'prop-types';
import I18n from 'I18n';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import UISelect from 'UIComponents/input/UISelect';
import { getAreFilesUploading } from 'FileManagerCore/selectors/UploadingFiles';
import getQueryFromLocation from '../utils/getQueryFromLocation';
import { jsx as _jsx } from "react/jsx-runtime";
const ArchiveFilter = ({
  onChange
}) => {
  const location = useLocation();
  const {
    archived
  } = getQueryFromLocation(location);
  const areFilesUploading = useSelector(getAreFilesUploading);
  return /*#__PURE__*/_jsx(UISelect, {
    disabled: areFilesUploading,
    buttonUse: "transparent",
    onChange: onChange,
    value: archived,
    options: [{
      text: I18n.text('FileManagerDashboard.activeDropdown.active'),
      value: false
    }, {
      text: I18n.text('FileManagerDashboard.activeDropdown.archived'),
      value: true
    }]
  });
};
ArchiveFilter.propTypes = {
  onChange: PropTypes.func.isRequired
};
export default ArchiveFilter;